module.exports = __webpack_public_path__ + "img/about_jianjie.6a202c68.jpg";